export const DIRECCIONES_DATA = {
  usa: {
    servicios: [
      {
        id: "kiflix",
        titulo: "Servicio KIFLIX",
        datos: {
          codigo: "ZON013557",
          direccion: "8095 NW 98th Street",
          ciudad: "Hialeah",
          estado: "Florida",
          postal: "33016",
          telefono: "+1 (786) 5572260",
          pais: "Estados Unidos",
        }
      },
      {
        id: "pro",
        titulo: "Servicio Pro",
        datos: {
          nombre: "Valeria Cucalon / Sebastian Villarreal",
          direccion: "331 NW 82nd AVE",
          apartamento: "APT 1305",
          ciudad: "Miami",
          estado: "Florida",
          postal: "33126",
          telefono: "+1 (786) 473-6458",
          pais: "Estados Unidos",
        }
      }
    ]
  },

  china: {
    servicios: [
      {
        id: "maritima",
        titulo: "Vía Marítima",
        datos: {
          empresa: "CHARTER LINK LOGISTICS LIMITED (GUANGZHOU BRANCH)",
          direccion: "FLAT E-F, 17/F., JIANHE CENTER, NO. 111 TIYUXI ROAD, THIANE DISTRICT, GUANGZHOU, CHINA",
          telefono: "+020-38781829-860",
          fax: "852-28514312",
          contacto: "Ms Chara",
          email: "op9.gz@charter-link.com"
        }
      },
      {
        id: "aerea",
        titulo: "Vía Aérea",
        datos: {
          importador: "Sebastian Villarreal",
          tipoCarga: "COURIER GLOBAL",
          agente: "EVERGRAND - Melody Yan",
          telefono: "13544302943 / 13686298192",
          direccion: "360 WHR, GUANGHUA STATION, NO 2721 OF QIRPORT ROAD, BAIYUN DISTRICT, GUANGZHOU"
        }
      }
    ]
  },

  espana: {
    servicios: [
      {
        id: "espana",
        titulo: "Dirección España",
        datos: {
          nombre: "Sebastian Villarreal",
          direccion: "Calle de Albasanz 52, Local B Izq 387601",
          apartamento: "387601",
          ciudad: "Madrid",
          estado: "Madrid",
          postal: "28037",
          telefono: "+34 646552799"
        }
      }
    ]
  }
};
